/// <amd-module name="VSS/Redux/Modules/Telemetry/TelemetryContracts" />

export interface ITelemetryModuleArgs {
    area: string;
    serviceInstanceType?: string;
}